/*
 *  Copyright (c) Qwoach LLC 2020. All rights reserved.
 *  Unauthorized copying of this file, via any medium is strictly prohibited
 *  Proprietary and confidential
 *  Created by Artem Bogush <artem@qwoach.com> on 7/10/2020
 */

import DbBaseObject from "@shared/DbBaseObject.js";


export default class PersonalInfoContainer extends DbBaseObject{

	spouseName: string = null
	childrenNames: string = null


	constructor(name: string = null) {
		super();
		this.name = name;
	}
}
